/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_App_BodyInputs */

const en_price_page_app_body = /** @type {(inputs: Price_Page_App_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start free with 3 workouts and 3 meal scans, no card needed. Then everything you train with between visits. Cancel in Settings any time.`)
};

const pl_price_page_app_body = /** @type {(inputs: Price_Page_App_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zacznij za darmo: 3 treningi i 3 skany posiłków, bez karty. Potem wszystko, z czym trenujesz między wizytami. Anulujesz w Ustawieniach w każdej chwili.`)
};

/**
* | output |
* | --- |
* | "Start free with 3 workouts and 3 meal scans, no card needed. Then everything you train with between visits. Cancel in Settings any time." |
*
* @param {Price_Page_App_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_app_body = /** @type {((inputs?: Price_Page_App_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_App_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_app_body(inputs)
	return en_price_page_app_body(inputs)
});